import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RenderInput } from './Base';
import { Viewer } from "../../../widgets/Viewer";

import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';

import { saveReceipt } from '../../../../redux/actions/receipt.actions';

const mapStateToProps = (state) => ({
    receipt: state.receipt,
    general: state.general
});

class AddReceiptModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            recipient_guardian_full_name: '',
            signed: false,
            date_received: new Date(),
            amount_requested: 0,
            amount_received: 0,
            image: '',
            filename: '',
            dropbox_image_share_url: '',
            currency: 'CAD'
        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
    }
    componentDidMount() {
        window.addEventListener('open-receipt-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-receipt-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { receipt: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        const form = detail.id ? { ...detail } : { ...detail, ...this.emptyForm };
        this.setState({ showModal: true, form });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value, file }) => {
        const { form } = this.state;

        // Extract last file
        if (file && file[0]) {
            const reader = new FileReader();
            const lastFile = file[0];
            reader.readAsDataURL(lastFile);
            reader.onloadend = () => {
                form.image = reader.result;
                this.setState({ form });
            }
            form.filename = lastFile.name;
        }
        if (text !== undefined) {
            form[value] = text;
        }

        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveProgress();
        }
    }
    saveReceipt = () => {
        const newForm = { ...this.state.form }
        if (newForm.image) {
            newForm.image = newForm.image.split(',')[1];
        }
        this.props.saveReceipt(newForm);
    }
    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.receipt;
        const { supportedCurrencies } = this.props.general;
        const currencies = Object.keys(supportedCurrencies);
        return (
            <Dialog icon='envelope'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                canOutsideClickClose={false}
                title="Add Receipt">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="Guardian Full Name"
                                    name="recipient_guardian_full_name"
                                    value={form.recipient_guardian_full_name}
                                    autoFocus
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Date Received"
                                    name="date_received"
                                    value={form.date_received}
                                    datePicker
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Amount Requested (in $)"
                                    name="amount_requested"
                                    value={form.amount_requested}
                                    type="numeric"
                                    onChangeHandler={this.onChangeHandler}/>
                                <RenderInput label="Amount Received (in $)"
                                    name="amount_received"
                                    value={form.amount_received}
                                    type="numeric"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Currency"
                                        name="currency"
                                        value={form.currency}
                                        type="select"
                                        items={currencies}
                                        onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput name="filename"
                                    type="upload"
                                    value={form.filename}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Signed"
                                    name="signed"
                                    value={form.signed}
                                    type="checkbox"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                { form.image || form.dropbox_image_share_url ?
                                     <div className="flex-column">
                                        <Viewer src={form.image || form.dropbox_image_share_url || ''} style={{ width: '100%' }} />
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Save Receipt" onClick={this.saveReceipt} isLoading={saveLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveReceipt }
)(AddReceiptModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/ReceiptModal.jsx